export default __webpack_public_path__ + "8992052bdeaf21ee59d857da4ec66604.webp";